<script setup>
import { ref } from 'vue';
import boxImg from './box-img.png';
const proofDialog = ref(false);
</script>

<template>
  <div>
    <q-btn
      color="blue"
      label="View Proof"
      rounded
      size="sm"
      class="font-semibold"
      @click="proofDialog = true"
    />
    <q-dialog v-model="proofDialog">
      <q-card
        class="p-4 flex-col items-center justify-center w-sm"
        style="width: 300px"
      >
        <q-card-section class="row items-center q-pb-none">
          <div class="text-h6">Proof Uploaded</div>
          <q-space />
          <q-btn icon="close" flat round dense v-close-popup />
        </q-card-section>
        <q-separator spaced class="my-4" />
        <q-img
          :src="boxImg"
          spinner-color="primary"
          spinner-size="82px"
          style="height: 117px"
          contain
        />
        <div class="flex justify-center items-center w-full">
          No data available
        </div>
      </q-card>
    </q-dialog>
  </div>
</template>
